import { render, staticRenderFns } from "./TheFormTowns.vue?vue&type=template&id=7371f752&scoped=true&"
import script from "./TheFormTowns.vue?vue&type=script&lang=ts&"
export * from "./TheFormTowns.vue?vue&type=script&lang=ts&"
import style0 from "./TheFormTowns.vue?vue&type=style&index=0&id=7371f752&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7371f752",
  null
  
)

export default component.exports